import { useCallback, useEffect, useRef, useState } from 'react';
// @mui
import {
    Box,
    List,
    Badge,
    Tooltip,
    Divider,
    Popover,
    Typography,
    IconButton,
    ListSubheader,
    Tab,
    Tabs,
} from '@mui/material';
// utils
// components
import { eventList, glb_sv, sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import { TabContext } from '@mui/lab';
import Iconify from 'src/components/iconify';
import ListNotification from './notification';
import ListNotiWarning from './warning';
import useHookNoti from './notification/useHookNoti';
import useHookWarning from './warning/useHookWarning';

// ----------------------------------------------------------------------

export default function NotificationsPopoverV2() {
    const getCheckRef = useRef(false);

    const [value, setValue] = useState('notify');

    const user = glb_sv.userInfo;
    const isAdmin = user?.group_user === '1';

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [open, setOpen] = useState(null);
    const handleClose = () => {
        readNotify();
        setOpen(null);
    };

    const {
        getDataNotification,
        handleScrollToBottomNotification,
        loadingNotification,
        listNotification,
        setListNotification,
        readNotifyRef,
        totalUnReadNotify,
        totalNotification,
        getNotiStopRef,
        lastIDNotification,
        setTotalUnReadNotify,
    } = useHookNoti();

    const {
        getDataWarning,
        handleScrollToBottomWarning,
        loadingWarning,
        getWarningStopRef,
        listWarning,
        setListWarning,
        totalUnReadWarning,
        totalNotiWarning,
        lastIDWarning,
    } = useHookWarning();

    useEffect(() => {
        const userData = sessionStorage.getItem('proc_data');
        if (userData) {
            setListNotification(JSON.parse(JSON.stringify([])));
            setTimeout(() => {
                getDataNotification();
            }, 1000);
            setTimeout(() => {
                checkwarning();
            }, 1500);
        }
    }, []);
    // useEffect(() => {
    //     setTimeout(() => {

    //     }, 1500);
    // }, []);

    useEffect(() => {
        glb_sv.commonEvent.subscribe((msg) => {
            if (msg.type === eventList.ADD_NOTIFY) {
                setTotalUnReadNotify(prev => prev + 1);
            }
        });
    }, []);

    // useEffect(() => {
    //     setTotalUnRead(totalUnReadNotify + totalUnReadWarning);
    // }, [totalUnReadNotify, totalUnReadWarning]);

    // check warnings
    const checkwarning = useCallback(() => {
        if (getCheckRef.current) {
            return;
        }
        getCheckRef.current = true;
        const InVal = [];
        sendRequest(serviceList.checkWarning, InVal, checkwarningResult, true, timeOutFunctCheck, 40000);
    }, []);

    const checkwarningResult = (reqInfoMap, message) => {
        getCheckRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            getDataWarning();
        }
    };

    const timeOutFunctCheck = (reqInfo) => {
        getCheckRef.current = false;
    };

    const readNotify = () => {
        if (readNotifyRef.current) return;
        readNotifyRef.current = true;
        const listNotificationNew = listNotification
            .filter((ele) => ele.status_notify === '1')
            .map((ele) => ele.notify_id);
        const listNotificationWarningNew = listWarning
            .filter((ele) => ele.status_notify === '1')
            .map((ele) => ele.notify_id);
        const allNotify = [...listNotificationNew, ...listNotificationWarningNew];
        if (allNotify.length === 0) return;
        if (allNotify.length === 0) return;
        const InVal = ['0', JSON.stringify([...listNotificationNew, ...listNotificationWarningNew])];
        sendRequest(serviceList.readerNotification, InVal, readNotifyResult, true, timeOutFunctReader, 40000);
    };

    const readNotifyResult = (reqInfoMap, message) => {
        readNotifyRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setListNotification([]);
            getDataNotification();
            setTimeout(() => {
                setListWarning([]);
                getDataWarning();
            }, 1000);
        }
    };

    const timeOutFunctReader = (reqInfo) => {
        readNotifyRef.current = false;
    };

    const handleOpen = (event) => {
        setOpen(event.currentTarget);
    };

    return (
        <>
            <IconButton color={open ? 'primary' : 'default'} onClick={handleOpen} sx={{ width: 40, height: 40 }}>
                <Badge badgeContent={totalUnReadNotify + totalUnReadWarning} color="error">
                    <Iconify icon="eva:bell-fill" width={27} height={27} />
                </Badge>
            </IconButton>

            <Popover
                open={Boolean(open)}
                anchorEl={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: {
                        mt: 1.5,
                        ml: 0.75,
                        width: 460,
                    },
                }}
            >
                <Box sx={{ display: 'flex', bgcolor: 'action.selected', alignItems: 'center', py: 2, px: 2.5 }}>
                    <Box sx={{ flexGrow: 1 }}>
                        <Typography variant="subtitle1">{t('notify')}</Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            {t('your_is')} {totalNotification} {t('notify').toLocaleLowerCase()}, {totalNotiWarning}{' '}
                            {t('warning').toLocaleLowerCase()}
                        </Typography>
                    </Box>

                    {totalUnReadNotify + totalUnReadWarning > 0 && (
                        <Tooltip title={t('check_is_read')}>
                            <IconButton color="primary" onClick={readNotify}>
                                <Iconify icon="eva:done-all-fill" />
                            </IconButton>
                        </Tooltip>
                    )}
                </Box>

                <Divider sx={{ borderStyle: 'dashed' }} />
                <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
                    <TabContext value={value}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            textColor="primary"
                            sx={{ bgcolor: 'action.selected' }}
                            aria-label="basic tabs example"
                        >
                            <Tab
                                onClick={() => {
                                    getNotiStopRef.current = false;
                                    getWarningStopRef.current = true;
                                }}
                                label={
                                    <Badge badgeContent={totalUnReadNotify} color="error">
                                        {t('notify')} ({listNotification.length} / {totalNotification})
                                    </Badge>
                                }
                                value={'notify'}
                            />
                            {isAdmin && (
                                <Tab
                                    onClick={() => {
                                        getNotiStopRef.current = true;
                                        getWarningStopRef.current = false;
                                    }}
                                    label={
                                        <Badge badgeContent={totalUnReadWarning} color="error">
                                            {t('warning')} ({listWarning.length} / {totalNotiWarning})
                                        </Badge>
                                    }
                                    value={'warning'}
                                />
                            )}
                        </Tabs>
                        {/* tap con */}
                        <ListNotification
                            value={value}
                            totalNotification={totalNotification}
                            listNotification={listNotification}
                            handleClose={handleClose}
                            handleScrollToBottom={handleScrollToBottomNotification}
                            loading={loadingNotification}
                        />

                        <ListNotiWarning
                            value={value}
                            totalNotiWarning={totalNotiWarning}
                            listWarning={listWarning}
                            handleClose={handleClose}
                            handleScrollToBottom={handleScrollToBottomWarning}
                            loading={loadingWarning}
                        />
                    </TabContext>
                </Box>
            </Popover>
        </>
    );
}
